document.addEventListener("DOMContentLoaded", function () {

  function highlightLocation() {

    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    let node;
    const nodes = [];

    while (node = walker.nextNode()) {
      if (
        node.nodeValue.includes("METRO VANCOUVER") ||
        node.nodeValue.includes("ONTARIO")
      ) {
        nodes.push(node);
      }
    }

    nodes.forEach(node => {

      // skip
      if (node.parentNode.classList && node.parentNode.classList.contains("highlighted-location")) {
        return;
      }

      const span = document.createElement("span");
      span.textContent = node.nodeValue;

      // color
      if (node.nodeValue.includes("ONTARIO")) {
        span.style.color = "#468020ff";
      }

      if (node.nodeValue.includes("METRO VANCOUVER")) {
        span.style.color = "#791b22ff";
      }

      span.style.fontWeight = "700";
      span.style.fontSize = "16px";

      span.classList.add("highlighted-location");

      node.parentNode.replaceChild(span, node);
    });
  }

  highlightLocation();

  document.body.addEventListener("click", function () {
    setTimeout(highlightLocation, 800);
  });

});